export default __webpack_public_path__ + "static/media/Diageo.svg.0796095c.png";